import React from 'react';
import PropTypes from 'prop-types';
import { WithBackendConfig } from '../providers/BackendConfigProvider/BackendConfigProvider';
import ReactGA from 'react-ga';

const Analytics = ({ children, backendConfig }) => {
  if (backendConfig && backendConfig.gaTrackingCode) {
    ReactGA.initialize(backendConfig.gaTrackingCode);
    ReactGA.pageview(window.location.pathname);
  }

  return <>{children}</>;
};

Analytics.propTypes = {
  backendConfig: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
};

Analytics.displayName = 'Analytics';

export default WithBackendConfig(Analytics);
